export type SoundType = string;

export interface SoundDefinition {
    [sound: SoundType]: string;
}
